import { colors } from '../themes'
import { hexToRgba } from '../themes/helpers'

// Extracted from
// http://lea.verou.me/2012/04/background-attachment-local/
export const scrollGradient = {
  backgroundImage: `linear-gradient(${colors.white}, ${hexToRgba(colors.white, 0)}),
    linear-gradient(to top, ${colors.white}, ${hexToRgba(colors.white, 0)}),
    linear-gradient(${hexToRgba(colors.grayChateau, 0.15)}, ${hexToRgba(colors.grayChateau, 0)}),
    linear-gradient(to top, ${hexToRgba(colors.grayChateau, 0.15)}, ${hexToRgba(colors.grayChateau, 0)})`,
  backgroundPosition: '0 0, 0 100%, 0 0, 0 100%',
  backgroundSize: '100% 50px, 100% 50px, 100% 20px, 100% 20px',
  backgroundRepeat: 'no-repeat',
  backgroundColor: colors.white,
  backgroundAttachment: 'local, local, scroll, scroll',
}

// Accessibly hide an element, so that is still
// shown in the accessibility tree
export const accessiblyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  clipPath: 'polygon(0 0, 0 0, 0 0)',
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: 1,
  whiteSpace: 'nowrap',
}
